import { render } from "./TasksOverviewList.vue?vue&type=template&id=2191e4e7"
import script from "./TasksOverviewList.vue?vue&type=script&lang=js"
export * from "./TasksOverviewList.vue?vue&type=script&lang=js"

import "./TasksOverviewList.vue?vue&type=style&index=0&id=2191e4e7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__